// CommentArea.js
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { TwitterShareButton } from 'react-share'
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function CommentArea({ reelResult, spinning, ss }) {
    const [text, setText] = useState('');

    const { register, handleSubmit, formState: { errors } } = useForm();
    const shareMsg = "【"+ reelResult.join("")+"】から「"  +text + "」というお話 "
    const hashTag = ['eruri_slot']
    const url = window.location.href

    return (
        <div className={`comment_area ${spinning ? 'spinning' : ''} ${reelResult.length === 0 || reelResult[0] === undefined ? 'spinning' : ''}`}>
            <form>
                <CardHeader
                    title="あなたのエルリスロットの結果"
                    titleTypographyProps={{ align: 'center' }}
                    subheaderTypographyProps={{
                        align: 'center',
                    }}
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[200]
                                : theme.palette.grey[700],
                        pt:1,
                        pb:1,
                    }}
                />
                <CardContent sx={{pt:1, pb:1}}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'baseline',
                        }}
                    >
                        <Typography variant="h6" color="text.primary">
                            {reelResult.join(" ")}
                        </Typography>
                    </Box>
                    <ul>
                            <Typography
                                component="li"
                                variant="subtitle1"
                                align="center"
                            >
                                この結果に対する素敵な妄想をどうぞ
                            </Typography>
                    </ul>
                </CardContent>
                <TextField
                    {...register("userComment", { required: true })}
                    label="妄想をどうぞ"
                    fullWidth
                    margin="normal"
                    rows={2}
                    multiline
                    variant="outlined"
                    onChange={(event) => setText(event.target.value)}
                />
                {errors.userComment && errors.userComment.type === "required" && <p>This is required</p>}
                {errors.userComment && errors.userComment.type === "maxLength" && <p>Your input exceed maxLength</p>}
                <TwitterShareButton url={url} title={shareMsg} hashtags={hashTag}>
                    <Button fullWidth variant="contained" sx={{backgroundColor:'#1DA1F2'}}>
                        Twitterでシェア  <FontAwesomeIcon icon={faTwitterSquare} />
                    </Button>
                </TwitterShareButton>
                <CardContent style={{ display:'flex', justifyContent:'center' }}>
                <Typography variant="subtitle1" className="tategaki" component="div" dangerouslySetInnerHTML={{ __html: ss }} sx={{lineHeight:1.4}}/>
                </CardContent>

            </form>
        </div>
    );
}

export default CommentArea;
